<div class="n-postal-address-row" [formGroup]="formGroup">
    <mat-form-field appearance="outline" class="n-flex-field">
        <mat-label>(line 1) {{addressRequired ? '*' : ''}}</mat-label>
        <input matInput formControlName="address1">
        @if (formGroup.hasError('requiredAddress')) {
        <mat-error>
            Address can't be empty
        </mat-error>
        }
        @if (formGroup.hasError('requiredAddressIncomplete')) {
        <mat-error>
            Address is required but incomplete
        </mat-error>
        }
        @if (formGroup.hasError('optionalAddressIncomplete')) {
        <mat-error>
            Address is incomplete
        </mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" class="n-flex-field">
        <mat-label>Address (line 2)</mat-label>
        <input matInput formControlName="address2">
    </mat-form-field>

    <mat-form-field appearance="outline" class="n-fixed-field">
        <mat-label>Zip code{{addressRequired ? '*' : ''}}</mat-label>
        <input matInput formControlName="zipCode">
    </mat-form-field>

    <mat-form-field appearance="outline" class="n-flex-field">
        <mat-label>City{{addressRequired ? '*' : ''}}</mat-label>
        <input matInput formControlName="city">
    </mat-form-field>

    <mat-form-field appearance="outline" class="n-flex-field">
        <mat-label>Country</mat-label>
        <input matInput type="text" formControlName="countryIsoCode" [matAutocomplete]="countryAuto">
        <mat-autocomplete #countryAuto="matAutocomplete" [displayWith]="displayFn">
            @for (c of filteredCountries; track c.isoCode) {
            <mat-option [value]="c.isoCode">
                {{ c.enName }}
            </mat-option>
            }
        </mat-autocomplete>
        <mat-error>
            Country is required
        </mat-error>
    </mat-form-field>

</div>